import { render, staticRenderFns } from "./CustomerField.vue?vue&type=template&id=cb00bada&lang=pug&"
import script from "./CustomerField.vue?vue&type=script&lang=js&"
export * from "./CustomerField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CustomerField.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports